<template>
  <header class="flex gap-4 rounded-xl bg-white p-4 shadow-lg">
    <div class="flex h-fit grow items-center gap-4">
      <bv-avatar
        :image="contact?.avatar"
        :name
      />
      <div class="flex gap-2">
        <div class="flex flex-col">
          <h3 class="text-2xl font-semibold text-gray-900 capitalize">
            {{ name }}
          </h3>
          <p
            v-if="name !== number"
            class="text-lg text-gray-500"
          >
            {{ number }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap items-center justify-end gap-4">
      <router-link :to="profileRoute">
        <bv-btn
          class="h-10"
          :disabled="!contactId"
          variant="tonal"
        >
          <vsx-icon
            color="var(--color-base-500)"
            icon-name="Eye"
            :size="16"
            type="linear"
          />
          {{ $t('call_center.view_profile') }}
        </bv-btn>
      </router-link>
      <bv-btn
        class="h-10"
        color="var(--color-green-500)"
        :disabled="!isValidE164 || !hasChatService"
        @click="chat"
      >
        <chat-box-icon
          height="16"
          width="16"
        />
        {{ $t('call_center.chat') }}
      </bv-btn>
      <bv-btn
        class="h-10"
        @click="handleMakeCall"
      >
        <vsx-icon
          color="#fff"
          icon-name="Call"
          :size="16"
          type="linear"
        />
        {{ $t('call_center.call') }}
      </bv-btn>
    </div>
  </header>
</template>

<script>
  import { sip } from '@bv/utils';
  import { isValidPhoneNumber } from 'libphonenumber-js';
  import { mapState } from 'pinia';

  import ChatApi from '@/api/chat/chat.api';
  import contactApi from '@/api/webphone/contacts.api';
  import ChatBoxIcon from '@/components/Icons/ChatBox.vue';
  import { userDetailsStore } from '@/stores/auth/user-details.store';

  export default {
    name: 'CallLogHeader',
    components: {
      ChatBoxIcon,
    },
    data() {
      return {
        contact: undefined,
      };
    },
    computed: {
      ...mapState(userDetailsStore, ['hasChatService']),
      profileRoute() {
        return this.contactId
          ? {
              name: 'contact-details',
              params: { contactId: this.contactId },
            }
          : {};
      },
      number() {
        return this.$route.params.number;
      },
      name() {
        return this.contact?.full_name || this.number;
      },
      contactId() {
        return this.$route.query.id;
      },
      isValidE164() {
        return isValidPhoneNumber(this.number);
      },
    },
    watch: {
      contactId: {
        handler: 'getContact',
        deep: true,
        immediate: true,
      },
    },
    methods: {
      handleMakeCall() {
        sip.call(this.number);
      },
      navigateToDetails() {
        this.$router.push({
          name: 'contact-details',
          params: { contactId: this.contact.id },
        });
      },
      chat() {
        ChatApi.create(
          {
            name: this.name,
            phone_number: this.number,
          },
          undefined,
          undefined,
          { 'x-silent': true },
        ).then((response) => {
          if (response?.data?.data?.url) {
            window.open(response.data.data.url, '_blank');
          }
        });
      },
      getContact() {
        this.contact = undefined;

        if (!this.contactId) {
          return;
        }

        contactApi.show(this.contactId).then((response) => {
          this.contact = response.data.data;
        });
      },
    },
  };
</script>
